<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="this.consts.meetingType.customer">
      <b-overlay :show="overlayShow" rounded="sm">
        <div class="base-color mh-550 shadow">
          <div class="p-2">
            <img :src="hearingData('imagePath')" class="w-100">
            <div class="col-sm-12 text-center pt-4">
              <h2>{{hearingData('title')}}</h2>
            </div>
            <div class="col-sm-12 text-center pt-1">
              <h5>{{hearingData('subtitle')}}</h5>
            </div>
            <div class="col-sm-12 text-center pt-1 white-space-pre-wrap" v-html="getHearingBody()"></div>
          </div>
        </div>
      </b-overlay>
    </CustomerMeetingLayout>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import SignalingModel from '@/models/SignalingModel'
import CommonLogModel from '@/models/CommonLogModel'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'

export default {
  name: 'CustomerMeetingHearing',
  components: { CommonLayout, CustomerMeetingLayout },
  data () {
    return {
      overlayShow: false,
      signalingData: [],
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        // 接続確立しmeetingSessionが確立した後に要求を送る
        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          // 画面リロード時に情報の再送要求
          SignalingModel.sendAgainEvent()
        }
      }
    },
    getSignalingData (newData, oldData) {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$bvModal, newData, () => {
        })

        if (newData['id'] === 'reDrawMemoImage') {
          const tableRowId = 'tableRowId' in newData && newData['tableRowId'] ? newData['tableRowId'] : ''
          const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
          localStorage.currentProjectType = newData['projectType']
          localStorage.suggestionType = newData['suggestionType']
          this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'tableRowId': tableRowId}})
        } else if (newData['id'] === 'operationInvalid') {
          cstore.commit('setIsOperationPossible', false)
        }

        if (newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click' && (newData['id'] === 'next' || newData['id'] === 'back')) {
          this.$router.push(newData['target_path'])
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'productDetailFromBookmark') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            const targetPath = '/customer/meeting/product_selection/' + newData['projectNumber']
            this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'suggestionType': newData['suggestionType'], 'fromBookmark': true}})
          }
        }

        if (newData['event'] === 'api') {
          this.signalingData = newData.data.contents
          localStorage.currentProjectType = newData.data.project_type
          localStorage.suggestionType = newData.data.suggestion_type
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$bvModal, {'timestampMs': Date.now(), 'errorMessage': err.message}, () => {
        })
      }
    }
  },
  methods: {
    hearingData (key) {
      return this.signalingData[key]
    },
    getHearingBody () {
      let body = this.signalingData['body']
      if (body) {
        // bodyの会社名を置換
        body = body.replace('{会社名}', this.signalingData['companyName'])
        // bodyの改行を置換
        body = body.replace(/\\n/g, '<br/>')
      }
      return body
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CustomerMeetingHearing.vue